import {
  PIICategoryTypeParametersList,
  PIICategoryTypeParametersListMetadataArgs,
  getPIICategoryTypeParametersListMetadata,
} from '../../assets/ts/data/pii/pii-category-type-parameters'
import useServerData from '../use-server-data'

function usePiiCategoryTypeParametersMetadata(
  fetchArgs,
  waitOnParentDependency = false
) {
  const {
    data: piiCategoryTypeParameterMetadata,
    error: piiCategoryTypeParameterMetadataError,
    fetchData: fetchPiiCategoryTypeParameterMetadata,
    isLoading: piiCategoryTypeParameterMetadataIsLoading,
  } = useServerData<
    PIICategoryTypeParametersList,
    PIICategoryTypeParametersListMetadataArgs
  >(getPIICategoryTypeParametersListMetadata, fetchArgs, waitOnParentDependency)

  return {
    fetchPiiCategoryTypeParameterMetadata,
    piiCategoryTypeParameterMetadata,
    piiCategoryTypeParameterMetadataError,
    piiCategoryTypeParameterMetadataIsLoading,
  }
}

export default usePiiCategoryTypeParametersMetadata
